import { AccredibleAvatarComponentModule } from '@accredible-frontend-v2/components/avatar';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/components/icon';
import { AccredibleResponsiveMenuModule } from '@accredible-frontend-v2/components/responsive-menu';
import { SafeShareLinkDirective } from '@accredible-frontend-v2/directives/safe-share-link';
import { CapitalizeWordsPipe } from '@accredible-frontend-v2/pipes/capitalize-words';
import { AccredibleSyncOrAsyncPipeModule } from '@accredible-frontend-v2/pipes/sync-or-async';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseHeaderMenuComponent } from './base-header-menu.component';

const MATERIAL_MODULES = [MatMenuModule, MatButtonModule, MatIconModule];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AccredibleAvatarComponentModule,
    AccredibleIconComponentModule,
    AccredibleResponsiveMenuModule,
    AccredibleSyncOrAsyncPipeModule,
    SafeShareLinkDirective,
    ...MATERIAL_MODULES,
    TranslocoDirective,
    CapitalizeWordsPipe,
  ],
  exports: [BaseHeaderMenuComponent],
  declarations: [BaseHeaderMenuComponent],
  providers: [],
})
export class AccredibleBaseHeaderMenuComponentModule {}
